/**
 * Aviso de version nueva de la aplicacion.
 *
 * La actualizacion no se aplica sola a proposito: recargar la pagina a mitad de
 * recorrido, con un video en marcha o con una pregunta a medio responder, es
 * peor que esperar. Se avisa y decide la persona.
 */

import { useTranslation } from 'react-i18next';
import { useRegisterSW } from 'virtual:pwa-register/react';

export function AvisoActualizacion() {
  const { t } = useTranslation();
  const {
    needRefresh: [hayVersionNueva, setHayVersionNueva],
    updateServiceWorker,
  } = useRegisterSW();

  if (!hayVersionNueva) return null;

  return (
    <div
      role="status"
      className="fixed inset-x-3 bottom-3 z-[1500] mx-auto max-w-md rounded-2xl
                 border border-crema-200 bg-white p-4 shadow-lg"
    >
      <p className="text-sm font-medium text-tinta-900">{t('pwa.actualitzacio')}</p>
      <div className="mt-3 flex gap-2">
        <button
          type="button"
          className="boton-primario flex-1"
          onClick={() => {
            void updateServiceWorker(true);
          }}
        >
          {t('pwa.actualitzar')}
        </button>
        <button
          type="button"
          className="boton-secundario"
          onClick={() => {
            setHayVersionNueva(false);
          }}
        >
          {t('pwa.mesTard')}
        </button>
      </div>
    </div>
  );
}
